export interface ThemePreset {
  id: string;
  name: string;
  primary: string;
  accent: string;
  signature: string;
  recommended?: boolean;
  qa?: boolean;
}

export const THEME_PRESETS: readonly ThemePreset[] = [
  { id: 'ax1_core', name: 'AX1 Core', primary: '#2B63C5', accent: '#3F4FA3', signature: '#475569', recommended: true },
  { id: 'deep_ocean', name: 'Deep Ocean', primary: '#155E75', accent: '#0F766E', signature: '#475569' },
  { id: 'forest', name: 'Forest', primary: '#166534', accent: '#047857', signature: '#475569' },
  { id: 'slate', name: 'Slate', primary: '#334155', accent: '#4F46E5', signature: '#64748B' },
];

/** Development-only palettes retained for visual regression checks. */
export const QA_PRESETS: readonly ThemePreset[] = [
  { id: 'qa_high_contrast', name: 'QA High Contrast', primary: '#1D4ED8', accent: '#BE123C', signature: '#111827', qa: true },
];

export const RECOMMENDED_COLORS = {
  primary: ['#2B63C5'],
  accent: ['#3F4FA3'],
  signature: ['#475569'],
};

export function getPresetById(id: string): ThemePreset | undefined {
  return [...THEME_PRESETS, ...QA_PRESETS].find((preset) => preset.id === id);
}
